import { lazy } from 'react';

import { union } from 'lodash';

import { ALLOWED_ROLES } from 'packages/utils';

import { PATHS } from './constants';

const EventTypesList = lazy(() => import('./screens/EventTypesList'));
const EventType = lazy(() => import('./screens/EventType'));

const routesRoutes = [
  {
    component: EventTypesList,
    path: PATHS.BASE_URL,
    exact: true,
    allowedRoles: union(
      ALLOWED_ROLES.ORGANIZATIONS.EVENT_TYPES.LIST,
      ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.EVENT_TYPES.LIST,
    ),
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: EventType,
    path: PATHS.CREATE_EVENT_TYPE,
    overlay: true,
    writeOnly: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.EVENT_TYPES.CREATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: EventType,
    path: PATHS.EDIT_EVENT_TYPE,
    overlay: true,
    allowedRoles: union(
      ALLOWED_ROLES.ORGANIZATIONS.EVENT_TYPES.UPDATE,
      ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.EVENT_TYPES.UPDATE,
    ),
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
];

export default routesRoutes;
